import React, { useEffect, useMemo, useRef, useState } from "react";
import { useNavigate } from "react-router-dom";

const QUESTIONS = [
  {
    "id": "q1",
    "context": "library members",
    "measure": "Books read",
    "unit": "books",
    "min": 0,
    "max": 14,
    "groups": 3,
    "data": [
      2,
      7,
      1,
      12,
      5,
      9,
      4,
      0,
      11,
      8,
      6,
      3,
      14,
      7,
      2,
      10,
      5,
      1,
      8,
      4
    ],
    "resolution": 1,
    "calculator": "yes",
    "words": [
      "book",
      "read",
      "library",
      "member"
    ],
    "instruction": "The numbers below show the list number of books read by some members of a library.\nPresent the data in 3 suitable groups."
  },
  {
    "id": "q2",
    "context": "students taking a maths test",
    "measure": "Test score",
    "unit": "marks",
    "min": 1,
    "max": 30,
    "groups": 3,
    "data": [
      15,
      24,
      6,
      8,
      29,
      6,
      12,
      17,
      24,
      22,
      25,
      30,
      18,
      3,
      11,
      7,
      18,
      27,
      28,
      27
    ],
    "resolution": 1,
    "calculator": "yes",
    "comment": true,
    "words": [
      "student",
      "score",
      "mark",
      "test"
    ],
    "instruction": "The numbers below show the maths test scores of some students.\nPresent the data in 3 suitable groups.\nMake one comment about what the results show."
  },
  {
    "id": "q3",
    "context": "plants at a garden centre",
    "measure": "Plant height",
    "unit": "cm",
    "min": 31,
    "max": 120,
    "groups": 3,
    "data": [
      48,
      89,
      62,
      35,
      50,
      104,
      64,
      73,
      92,
      49,
      51,
      36,
      99,
      64,
      114,
      44,
      71,
      86,
      95,
      77
    ],
    "resolution": 1,
    "calculator": "yes",
    "comment": true,
    "words": [
      "plant",
      "height",
      "tall",
      "short",
      "garden"
    ],
    "instruction": "The numbers below show the heights of some plants at a garden centre, in cm.\nPresent the data in 3 suitable groups.\nMake one comment about what the results show."
  },
  {
    "id": "q4",
    "context": "students travelling to college",
    "measure": "Journey time",
    "unit": "minutes",
    "min": 0,
    "max": 39,
    "groups": 4,
    "data": [
      3,
      12,
      18,
      25,
      32,
      6,
      14,
      8,
      21,
      17,
      9,
      28,
      34,
      19,
      11,
      24,
      16,
      7,
      30,
      13,
      22,
      15,
      5,
      26
    ],
    "resolution": 1,
    "calculator": "yes",
    "chart": true,
    "tick": 2,
    "words": [
      "student",
      "journey",
      "travel",
      "college",
      "minute"
    ],
    "instruction": "The numbers below show some students journey times to college, in minutes.\nPresent the data in 4 suitable groups.\nDraw a bar chart of your grouped data."
  },
  {
    "id": "q5",
    "context": "letters posted by a business",
    "measure": "Letter mass",
    "unit": "g",
    "min": 1,
    "max": 50,
    "groups": 5,
    "data": [
      5,
      18,
      31,
      45,
      22,
      14,
      7,
      39,
      26,
      48,
      11,
      24,
      36,
      42,
      9,
      17,
      29,
      33,
      46,
      20,
      8,
      25,
      38,
      44,
      12
    ],
    "resolution": 1,
    "calculator": "yes",
    "chart": true,
    "tick": 2,
    "words": [
      "letter",
      "mass",
      "weigh",
      "business",
      "gram"
    ],
    "instruction": "The numbers below show the masses of some letters posted by a business, in grams.\nPresent the data in 5 suitable groups.\nDraw a bar chart of your grouped data."
  },
  {
    "id": "q6",
    "context": "customers shopping at a market",
    "measure": "Amount spent",
    "unit": "£",
    "min": 0,
    "max": 59,
    "groups": 3,
    "data": [
      8,
      32,
      17,
      45,
      23,
      56,
      12,
      28,
      41,
      19,
      35,
      7,
      52,
      26,
      14,
      38,
      49,
      21,
      9,
      33,
      18,
      44,
      27,
      11
    ],
    "resolution": 1,
    "calculator": "yes",
    "comment": true,
    "words": [
      "customer",
      "spent",
      "spend",
      "shop",
      "market",
      "pound"
    ],
    "instruction": "The numbers below show how much some customers spent at a market, in pounds.\nPresent the data in 3 suitable groups.\nMake one comment about what the results show."
  },
  {
    "id": "q7",
    "context": "dogs at an animal shelter",
    "measure": "Dog age",
    "unit": "years",
    "min": 0,
    "max": 19,
    "groups": 4,
    "data": [
      1,
      6,
      3,
      12,
      8,
      4,
      2,
      16,
      7,
      5,
      11,
      9,
      3,
      14,
      6,
      4,
      10,
      2,
      8,
      17,
      5,
      1,
      13,
      7
    ],
    "resolution": 1,
    "calculator": "yes",
    "chart": true,
    "comment": true,
    "tick": 2,
    "words": [
      "dog",
      "age",
      "shelter",
      "year",
      "old",
      "young"
    ],
    "instruction": "The numbers below show the ages of some dogs at an animal shelter, in years.\nPresent the data in 4 suitable groups.\nDraw a bar chart of your grouped data.\nMake one comment about what the results show."
  },
  {
    "id": "q9",
    "context": "parcels sent by an online shop",
    "measure": "Parcel mass",
    "unit": "kg",
    "min": 0,
    "max": 3.9,
    "groups": 4,
    "data": [
      0.3,
      1.2,
      2.4,
      0.8,
      1.7,
      3.1,
      2.8,
      0.5,
      1.4,
      2.2,
      3.6,
      0.9,
      1.8,
      2.5,
      3.3,
      0.4,
      1.1,
      2.9,
      1.6,
      2.1,
      3.8,
      0.7,
      1.3,
      2.6
    ],
    "resolution": 0.1,
    "calculator": "yes",
    "chart": true,
    "comment": true,
    "tick": 2,
    "words": [
      "parcel",
      "mass",
      "weigh",
      "shop",
      "kg",
      "kilogram"
    ],
    "instruction": "The numbers below show the masses of some parcels, in kg, to the nearest 0.1 kg.\nPresent the data in 4 suitable groups.\nDraw a bar chart of your grouped data.\nMake one comment about what the results show."
  }
];

const STORAGE_KEY = "presenting_data_in_groups_quiz_v1";
const SUBMIT_URL =
  `${process.env.REACT_APP_HOMEWORK_API_URL || (process.env.NODE_ENV === "development" ? "http://localhost:5001" : "")}/api/homework/presenting-data-in-groups`;

function makeSubmissionId() {
  if (
    window.crypto &&
    typeof window.crypto.randomUUID === "function"
  ) {
    return window.crypto.randomUUID();
  }

  return `${Date.now()}-${Math.random().toString(36).slice(2)}`;
}

function ResultIcon({ type, size = 28 }) {
  const isCorrect = type === "correct";
  const colour = isCorrect ? "#138a5b" : "#d64545";
  const paleColour = isCorrect ? "#e7f7ef" : "#fdecec";

  return (
    <svg
      aria-label={isCorrect ? "Correct" : "Incorrect"}
      role="img"
      width={size}
      height={size}
      viewBox="0 0 32 32"
      style={{ display: "inline-block", flexShrink: 0 }}
    >
      <circle cx="16" cy="16" r="14" fill={paleColour} stroke={colour} strokeWidth="2" />
      {isCorrect ? (
        <path
          d="M9.2 16.2l4.3 4.4 9.5-10"
          fill="none"
          stroke={colour}
          strokeWidth="3.2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      ) : (
        <path
          d="M11 11l10 10M21 11L11 21"
          fill="none"
          stroke={colour}
          strokeWidth="3.2"
          strokeLinecap="round"
        />
      )}
    </svg>
  );
}

export default function PresentingDataInGroupsQuiz() {
  useEffect(() => {
    const previousTitle = document.title;
    document.title = 'Presenting Data in Groups';
    return () => { document.title = previousTitle; };
  }, []);

  const navigate = useNavigate();
  const questions = useMemo(() => QUESTIONS, []);

  const [studentName, setStudentName] = useState("");
  const [nameConfirmed, setNameConfirmed] = useState(false);
  const [current, setCurrent] = useState(0);
  const [, setStudentAnswer] = useState("");
  const [working, setWorking] = useState("");
  const [feedback, setFeedback] = useState(null);
  const [attempts, setAttempts] = useState(0);
  const [questionResults, setQuestionResults] = useState(Array(questions.length).fill(null));
  const [studentAnswers, setStudentAnswers] = useState(Array(questions.length).fill(""));
  const [workingAnswers, setWorkingAnswers] = useState(Array(questions.length).fill(""));
  const [attemptHistory, setAttemptHistory] = useState(Array.from({ length: questions.length }, () => []));
  const [groupingProgress, setGroupingProgress] = useState({});
  const [checkedGrouping, setCheckedGrouping] = useState({});
  const [reviewMode, setReviewMode] = useState(false);
  const [done, setDone] = useState(false);
  const [submissionStatus, setSubmissionStatus] = useState("idle");
  const [submissionError, setSubmissionError] = useState("");
  const [submissionId, setSubmissionId] = useState(makeSubmissionId);

  useEffect(() => {
    try {
      const data = JSON.parse(localStorage.getItem(STORAGE_KEY) || "null");
      if (!data) return;
      // Keep saved answers aligned when removing the former questions 8 and 10.
      if(data.questionResults?.length===10){
        const retained=[0,1,2,3,4,5,6,8];
        for(const key of ['questionResults','studentAnswers','workingAnswers','attemptHistory']){
          if(Array.isArray(data[key]))data[key]=retained.map(i=>data[key][i]);
        }
        data.current=Math.min(data.current||0,7);
        delete data.groupingProgress?.q8;delete data.groupingProgress?.q10;
        delete data.checkedGrouping?.q8;delete data.checkedGrouping?.q10;
        localStorage.setItem(STORAGE_KEY,JSON.stringify(data));
      }
      setStudentName(data.studentName || "");
      setNameConfirmed(Boolean(data.nameConfirmed));
      setCurrent(Number.isInteger(data.current) ? data.current : 0);
      if (Array.isArray(data.questionResults) && data.questionResults.length === questions.length) setQuestionResults(data.questionResults);
      if (Array.isArray(data.studentAnswers) && data.studentAnswers.length === questions.length) setStudentAnswers(data.studentAnswers);
      if (Array.isArray(data.workingAnswers) && data.workingAnswers.length === questions.length) setWorkingAnswers(data.workingAnswers);
      if (Array.isArray(data.attemptHistory) && data.attemptHistory.length === questions.length) setAttemptHistory(data.attemptHistory);
      setCheckedGrouping(data.checkedGrouping || {});
      setGroupingProgress(data.groupingProgress || {});
      setDone(Boolean(data.done));
      setSubmissionStatus(data.submissionStatus || "idle");
      setSubmissionError(data.submissionError || "");
      setSubmissionId(data.submissionId || makeSubmissionId());
      const index = Number.isInteger(data.current) ? data.current : 0;
      setStudentAnswer(data.studentAnswers?.[index] || "");
      setAttempts(data.attemptHistory?.[index]?.length || 0);
      setWorking(data.workingAnswers?.[index] || "");
    } catch {
      localStorage.removeItem(STORAGE_KEY);
    }
  }, [questions.length]);

  const saveProgress = (override = {}) => {
    const payload = {
      studentName, nameConfirmed, current, questionResults, studentAnswers,
      workingAnswers, attemptHistory, checkedGrouping, groupingProgress, done, submissionStatus, submissionError, submissionId, ...override,
    };
    localStorage.setItem(STORAGE_KEY, JSON.stringify(payload));
  };

  const confirmName = (event) => {
    event.preventDefault();
    const cleanName = studentName.trim();
    if (!cleanName) return;
    setStudentName(cleanName);
    setNameConfirmed(true);
    saveProgress({ studentName: cleanName, nameConfirmed: true });
  };

  const checkAnswer = () => {
    const q=questions[current],model=groupingProgress[q.id]||emptyGrouping(q);
    if(model.rows.some(r=>['lower','upper','frequency'].some(key=>String(r[key]??'').trim()===''))){setFeedback('Complete every class limit and frequency before checking.');return;}
    const assessment=assessGrouping(q,model),isCorrect=assessment.correct;
    const entered=groupingSummary(q,model),updatedChecked={...checkedGrouping,[q.id]:assessment};
    setCheckedGrouping(updatedChecked);setStudentAnswer(entered);void playQuizFeedback(isCorrect);
    const updatedStudentAnswers = [...studentAnswers];
    const updatedWorkingAnswers = [...workingAnswers];
    const updatedHistory = attemptHistory.map((history) => [...history]);
    updatedStudentAnswers[current] = entered;
    updatedWorkingAnswers[current] = working;
    updatedHistory[current].push(entered);

    const updatedResults = [...questionResults];
    const newAttempts = attempts + 1;
    setAttempts(newAttempts);
    setStudentAnswers(updatedStudentAnswers);
    setWorkingAnswers(updatedWorkingAnswers);
    setAttemptHistory(updatedHistory);

    if (isCorrect) {
      updatedResults[current] = "correct";
      setQuestionResults(updatedResults);
      setFeedback(
        <div style={styles.statusLine}>
          <ResultIcon type="correct" />
          <strong style={{ color: "#087f5b" }}>{assessment.comment.status==='review'?'Your table/chart is correct. Your comment has been saved for Ryan to review.':'Correct!'}</strong>
        </div>
      );
    } else if (newAttempts >= 3) {
      updatedResults[current] = "incorrect";
      setQuestionResults(updatedResults);
      setFeedback("One valid example is shown in blue. Other correct groupings are also accepted. You can move on now.");
    } else {
      setFeedback(
        <div style={styles.statusLine}>
          <ResultIcon type="incorrect" />
          <strong style={{ color: "#c0392b" }}>
            Try again. Attempts left: {3 - newAttempts}
          </strong>
        </div>
      );
    }

    saveProgress({
      studentAnswers: updatedStudentAnswers,
      workingAnswers: updatedWorkingAnswers,
      attemptHistory: updatedHistory,
      questionResults: updatedResults, checkedGrouping: updatedChecked,
    });
  };

  const canAdvance = questionResults[current] === "correct" || questionResults[current] === "incorrect";

  const updateGroupingProgress = (values) => {
    const updated = { ...groupingProgress, [questions[current].id]: values };
    setGroupingProgress(updated);
    saveProgress({ groupingProgress: updated });
  };

  const submitResults = async (results, answers, histories, workings) => {
    setSubmissionError("");
    setSubmissionStatus("sending");
    saveProgress({ done: true, questionResults: results, studentAnswers: answers, attemptHistory: histories, workingAnswers: workings, submissionStatus: "sending" });

    const payload = {
      submissionId,
      studentName: studentName.trim(),
      quizTitle: "Presenting Data in Groups",
      completedAt: new Date().toISOString(),
      score: results.filter((result) => result === "correct").length,
      total: questions.length,
      questions: questions.map((question, index) => ({
        number: index + 1,
        question: question.instruction+' Data: '+question.data.join(', '),
        instruction:question.instruction+' Data: '+question.data.join(', '),
        table:{valueLabel:question.measure+' ('+question.unit+')',frequencyLabel:'Frequency',rows:(groupingProgress[question.id]?.rows||[]).map(r=>[intervalLabel(r,question),r.frequency])},
        correctAnswer:groupingSummary(question,exampleGrouping(question,groupingProgress[question.id])),
        commentReview:checkedGrouping[question.id]?.comment?.status==='review',
        comment:groupingProgress[question.id]?.comment||'',
        chart:question.chart?{heights:groupingProgress[question.id]?.bars||[],tick:question.tick||1,axisNumbers:groupingProgress[question.id]?.axisNumbers||[],axisLabels:groupingProgress[question.id]?.axisLabels||{},groupLabels:groupingProgress[question.id]?.groupLabels||[]}:null,
        studentAnswer: answers[index] || "No answer",
        attempts: histories[index] || [],
        working: workings[index] || "",
        result: results[index] || "incorrect",
      })),
    };

    try {
      const response = await fetch(SUBMIT_URL, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(payload),
      });
      if (!response.ok) {
        const messages = {
          404: "The results service could not be found. Please let Ryan know.",
          503: "Email delivery is not configured yet. Please let Ryan know.",
          502: "The email service could not deliver your results. Please try again later.",
        };
        throw new Error(messages[response.status] || "The results service could not accept your results. Please try again later.");
      }
      setSubmissionStatus("sent");
      saveProgress({ done: true, submissionStatus: "sent", submissionError: "" });
    } catch (error) {
      const message = error instanceof TypeError
        ? "Cannot connect to the results service. Please let Ryan know or try again later."
        : error.message;
      setSubmissionError(message);
      setSubmissionStatus("failed");
      saveProgress({ done: true, submissionStatus: "failed", submissionError: message });
    }
  };

  const nextQuestion = () => {
    setFeedback(null);
    setAttempts(0);
    const next = current + 1;

    if (next < questions.length) {
      setCurrent(next);
      setStudentAnswer(studentAnswers[next] || "");
      setWorking(workingAnswers[next] || "");
      saveProgress({ current: next });
      return;
    }

    if (reviewMode) {
      navigate("/student-dashboard");
      return;
    }

    setDone(true);
    saveProgress({ done: true });
    if (submissionStatus !== "sent") {
      submitResults(questionResults, studentAnswers, attemptHistory, workingAnswers);
    }
  };

  const previousQuestion = () => {
    if (current === 0) return;
    const previous = current - 1;
    setCurrent(previous);
    setFeedback(null);
    setAttempts(attemptHistory[previous]?.length || 0);
    setStudentAnswer(studentAnswers[previous] || "");
    setWorking(workingAnswers[previous] || "");
    saveProgress({ current: previous });
  };

  const startReview = () => {
    setReviewMode(true);
    setCurrent(0);
    setFeedback(null);
    setStudentAnswer(studentAnswers[0] || "");
    setWorking(workingAnswers[0] || "");
  };

  const retrySubmission = () => submitResults(questionResults, studentAnswers, attemptHistory, workingAnswers);
  const score = questionResults.filter((result) => result === "correct").length;

  const feedbackMessage = () => {
    const percentage = (score / questions.length) * 100;
    if (percentage === 100) return "🌟 Perfect—you got everything right!";
    if (percentage >= 80) return "🎉 Great job—you did really well!";
    if (percentage >= 50) return "👍 Good effort. Review any red questions.";
    return "💪 Keep practising. Reviewing your answers will help.";
  };

  const renderProgress = () => (
    <div style={styles.progressWrapper}>
      {questionResults.map((result, index) => (
        <div key={questions[index].id} style={{
          ...styles.progressDot,
          backgroundColor: result === "correct" ? "#00b894" : result === "incorrect" ? "#d63031" : "#636e72",
          border: index === current && !done ? "3px solid #f9b710" : "2px solid transparent",
        }}>
          {index + 1}
        </div>
      ))}
    </div>
  );

  if (!nameConfirmed) {
    return (
  
        <div style={styles.container}><style>{GROUP_CSS}</style>
          <div style={styles.nameCard}>
            <h1 style={styles.heading}>Presenting Data in Groups Quiz</h1>
            <p>Please enter your name before you begin. Your results will be sent to Ryan when you finish.</p>
            <form onSubmit={confirmName}>
              <label htmlFor="student-name" style={styles.label}>Your name</label>
              <input id="student-name" autoFocus autoComplete="name" maxLength={80} value={studentName}
                onChange={(event) => setStudentName(event.target.value)} style={styles.nameInput} />
              <button type="submit" disabled={!studentName.trim()} style={styles.startBtn}>Start Quiz ➡️</button>
            </form>
          </div>
        </div>
   
    );
  }

  const q = questions[current];
  const currentResult = questionResults[current];
  const completedFieldStyle =
    currentResult === "correct"
      ? styles.correctField
      : currentResult === "incorrect"
        ? styles.incorrectField
        : styles.unansweredField;

  return (
       <div style={styles.container}><style>{GROUP_CSS}</style>
        <h1 style={styles.heading}>Presenting Data in Groups</h1>
        <p style={styles.studentLabel}>Student: <strong>{studentName}</strong></p>
        {renderProgress()}

        {done && !reviewMode ? (
          <div style={styles.resultsBox}>
            <h2 style={{ fontFamily: "Inter, 'Segoe UI', sans-serif", color: "#17324d", fontWeight: 700 }}>Score: {score} / {questions.length}</h2>
            <p style={styles.feedbackText}>{feedbackMessage()}</p>
            {Object.values(checkedGrouping).some(item=>item.comment?.status==='review')&&<p>Some comments are waiting for Ryan’s review. Your score includes the automatically marked table and chart work.</p>}
            {submissionStatus === "sending" && <p>Sending your results to Ryan…</p>}
            {submissionStatus === "sent" && (
              <div style={{ ...styles.statusLine, ...styles.sentMessage }}>
                <ResultIcon type="correct" size={25} />
                <span>Your results have been sent to Ryan.</span>
              </div>
            )}
            {submissionStatus === "failed" && (
              <div>
                <p style={styles.errorMessage}>Your quiz is saved, but the results could not be sent.</p>
                {submissionError && <p role="alert">{submissionError}</p>}
                <button onClick={retrySubmission} style={styles.submitBtn}>Try Sending Again</button>
              </div>
            )}
            <button onClick={startReview} style={styles.reviewBtn}>🔍 Review Questions</button>
          </div>
        ) : (
          <div style={styles.card}>
            <h3 style={styles.questionHeading}>Question {current + 1} of {questions.length}</h3>
            <div style={{ display: "flex", alignItems: "flex-start", gap: 16, marginBottom: 24 }}>
              <div style={{...styles.instruction,flex:1,margin:0}}>{q.instruction.split('\n').map((line,i)=><p key={i} style={{margin:i===0?'0 0 14px':'14px 0 0'}}>{line}</p>)}</div>
              <div style={{ display: "flex", justifyContent: "flex-end", flexShrink: 0 }}>
                <CalculatorIcon allowed={q.calculator === "yes"} />
              </div>
            </div>
            <div className="group-raw-data" aria-label="Recorded data">{q.data.map((v,i)=><span key={i}>{q.unit==='£'?'£':''}{v}</span>)}</div>
            {questionResults[current]==='incorrect'&&<p style={styles.reviewAnswer}>One valid example is shown below. Your original response is saved for Ryan.</p>}
            <GroupingEditor question={q} model={questionResults[current]==='incorrect'?exampleGrouping(q,groupingProgress[q.id]):groupingProgress[q.id]||emptyGrouping(q)} checked={checkedGrouping[q.id]} example={questionResults[current]==='incorrect'} readOnly={reviewMode||canAdvance} onChange={updateGroupingProgress}/>
            {!reviewMode&&!canAdvance&&checkedGrouping[q.id]?.errors.length>0&&<ul className="group-marking-notes">{checkedGrouping[q.id].errors.map((error,i)=><li key={i}>{error}</li>)}</ul>}
            <label style={styles.label}>Show your working (optional):</label><textarea rows={3} readOnly={reviewMode||canAdvance} value={reviewMode?workingAnswers[current]:working} onChange={e=>setWorking(e.target.value)} style={{...styles.workingInput,...completedFieldStyle}}/>

            {reviewMode && (
              <div style={styles.reviewAnswer}>
                <div style={styles.statusLine}>
                  <ResultIcon type={questionResults[current] === "correct" ? "correct" : "incorrect"} />
                  <strong style={{ color: questionResults[current] === "correct" ? "#087f5b" : "#c0392b" }}>
                    {questionResults[current] === "correct" ? "Correct:" : "Correct answer:"}
                  </strong>
                </div>
                <p style={{whiteSpace:'pre-line'}}>{questionResults[current]==='correct'?studentAnswers[current]:groupingSummary(q,exampleGrouping(q,groupingProgress[q.id]))}</p>
              </div>
            )}
            {!reviewMode && feedback && <div style={styles.feedbackBox}>{feedback}</div>}
            {!reviewMode && !canAdvance && <button onClick={checkAnswer} style={styles.submitBtn}>Check Answer</button>}

            {(canAdvance || reviewMode) && (
              <div>
                {current > 0 && <button onClick={previousQuestion} style={styles.secondaryBtn}>← Back</button>}
                <button onClick={nextQuestion} style={styles.nextBtn}>
                  {current + 1 < questions.length ? "Next ➡️" : reviewMode ? "Finish Review" : "Finish & Send 🎉"}
                </button>
              </div>
            )}
          </div>
        )}
      </div>
    
  );
}

const styles = {
  container: { padding: "2rem", fontFamily: "'Fredoka', cursive", backgroundColor: "#eaf4fc", minHeight: "100vh" },
  heading: { fontFamily: "Inter, 'Segoe UI', sans-serif", fontSize: "clamp(1.6rem, 3vw, 2.25rem)", fontWeight: 700, lineHeight: 1.25, letterSpacing: "-0.035em", color: "#17324d", textAlign: "center", maxWidth: 760, margin: "0 auto 1.5rem", paddingBottom: "1rem", borderBottom: "3px solid #b8d4e8" },
  questionHeading: { fontFamily: "Inter, 'Segoe UI', sans-serif", fontSize: "1rem", fontWeight: 600, letterSpacing: "0.025em", color: "#475569", margin: "0 0 1.25rem" },
  studentLabel: { textAlign: "center", marginBottom: "1rem" },
  card: { backgroundColor: "#fff", padding: "2rem", borderRadius: 12, boxShadow: "0 4px 8px rgba(0,0,0,0.1)", maxWidth: 700, margin: "1rem auto 0" },
  nameCard: { backgroundColor: "#fff", padding: "2rem", borderRadius: 12, boxShadow: "0 4px 8px rgba(0,0,0,0.1)", maxWidth: 520, margin: "4rem auto" },
  nameInput: { display: "block", width: "100%", boxSizing: "border-box", padding: "0.75rem", margin: "0.5rem 0 1rem", border: "1px solid #aaa", borderRadius: 8, fontSize: "1.1rem" },
  startBtn: { padding: "0.7rem 1.3rem", backgroundColor: "#6c5ce7", color: "white", fontWeight: "bold", border: 0, borderRadius: 7, cursor: "pointer" },
  calculatorIndicator: { marginBottom: 12, display: "flex", justifyContent: "flex-end" },
  instruction: { fontWeight: 700, fontSize: "1.05rem", marginBottom: 24 },
  label: { fontFamily: "Inter, 'Segoe UI', sans-serif", color: "#334155", fontWeight: 600, marginTop: 10, display: "block" },
  mathInput: { display: "block", width: "100%", boxSizing: "border-box", fontSize: "1.25rem", padding: "0.65rem", borderRadius: 8, border: "1px solid #ccc", marginTop: 8 },
  workingInput: { width: "100%", boxSizing: "border-box", borderRadius: 8, border: "1px solid #ccc", padding: "0.75rem", fontSize: "1rem", fontFamily: "'Fredoka', cursive", marginTop: 8, marginBottom: 20 },
  unansweredField: { backgroundColor: "#fff", border: "1px solid #ccc" },
  correctField: { backgroundColor: "#e8f8ee", border: "2px solid #42a96b" },
  incorrectField: { backgroundColor: "#fdeaea", border: "2px solid #d95858" },
  feedbackBox: { marginTop: "1rem" },
  statusLine: { display: "flex", alignItems: "center", gap: 10 },
  reviewAnswer: { marginTop: "1rem", padding: "1rem", backgroundColor: "#f5f6fa", borderRadius: 8 },
  submitBtn: { marginTop: "1rem", padding: "0.6rem 1.2rem", backgroundColor: "#0984e3", color: "white", fontWeight: "bold", border: 0, borderRadius: 6, cursor: "pointer", marginRight: "0.75rem" },
  nextBtn: { marginTop: "1rem", padding: "0.6rem 1.2rem", backgroundColor: "#00b894", color: "white", fontWeight: "bold", border: 0, borderRadius: 6, cursor: "pointer" },
  secondaryBtn: { marginTop: "1rem", padding: "0.6rem 1.2rem", backgroundColor: "#636e72", color: "white", fontWeight: "bold", border: 0, borderRadius: 6, cursor: "pointer", marginRight: "0.75rem" },
  progressWrapper: { display: "flex", justifyContent: "center", gap: 10, marginBottom: "1.5rem", flexWrap: "wrap" },
  progressDot: { width: 36, height: 36, borderRadius: "50%", display: "flex", justifyContent: "center", alignItems: "center", fontWeight: "bold", color: "white" },
  resultsBox: { textAlign: "center", backgroundColor: "white", maxWidth: 700, margin: "2rem auto", padding: "2rem", borderRadius: 12, boxShadow: "0 4px 8px rgba(0,0,0,0.1)" },
  feedbackText: { fontSize: "1.25rem", margin: "1rem 0" },
  sentMessage: { color: "#087f5b", fontWeight: 700, justifyContent: "center", margin: "1rem 0" },
  errorMessage: { color: "#c0392b", fontWeight: 700 },
  reviewBtn: { marginTop: "1rem", padding: "0.6rem 1.2rem", backgroundColor: "#636e72", color: "white", fontWeight: "bold", border: 0, borderRadius: 6, cursor: "pointer" },
};


function CalculatorIcon({ allowed }) {
  const label = allowed ? "Calculator allowed" : "No calculator";

  return (
    <svg role="img" aria-label={label} width={56} height={40} viewBox="0 0 56 40"
      style={{ display: "block" }}>
      <title>{label}</title>
      <rect x="5" y="3" width="27" height="34" rx="4" fill="#f1f5f9" stroke="#334155" strokeWidth="2" />
      <rect x="10" y="8" width="17" height="7" rx="1" fill="#cbd5e1" stroke="#334155" />
      <path d="M11 21h2m5 0h2m5 0h2M11 27h2m5 0h2m5 0h2M11 32h2m5 0h2m5 0h2"
        stroke="#334155" strokeWidth="3" strokeLinecap="round" />
      {allowed ? (
        <path d="M37 22l5 5 9-12" fill="none" stroke="#138a5b" strokeWidth="4"
          strokeLinecap="round" strokeLinejoin="round" />
      ) : (
        <path d="M5 5l27 30M32 5L5 35" fill="none" stroke="#d64545" strokeWidth="4"
          strokeLinecap="round" />
      )}
    </svg>
  );
}

function numberValue(value){if(String(value??'').trim()==='')return NaN;const n=Number(String(value).trim());return Number.isFinite(n)?n:NaN;}
const close=(a,b)=>Math.abs(a-b)<1e-7;
const cleanNumber=n=>Number(Number(n).toFixed(4)).toString();
function intervalLabel(row,q){return `${row.lower}–${row.upper}${q.unit==='£'?' pounds':' '+q.unit}`;}
function emptyGrouping(q){return{rows:Array.from({length:q.groups},()=>({lower:'',upper:'',frequency:''})),bars:Array(q.groups).fill(null),axisNumbers:[],axisLabels:{},groupLabels:[],comment:''};}
function assessTable(q,model){
 const rows=(model.rows||[]).map(row=>({lower:numberValue(row.lower),upper:numberValue(row.upper),frequency:numberValue(row.frequency)})),errors=[];
 const finite=rows.length===q.groups&&rows.every(r=>Number.isFinite(r.lower)&&Number.isFinite(r.upper)&&r.upper>=r.lower&&close(r.lower/q.resolution,Math.round(r.lower/q.resolution))&&close(r.upper/q.resolution,Math.round(r.upper/q.resolution)));
 if(!finite)errors.push(`Enter ${q.groups} valid groups using ${q.resolution===1?'whole-number':'one-decimal-place'} limits.`);
 if(finite){
  const width=rows[0].upper-rows[0].lower+q.resolution;
  if(!rows.every(r=>close(r.upper-r.lower+q.resolution,width)))errors.push('All groups must have the same width.');
  if(rows.some((r,i)=>i&&!close(r.lower,rows[i-1].upper+q.resolution)))errors.push('Put the groups in order with no overlaps and no missing possible values.');
  if(rows[0].lower>q.min+1e-7||rows[rows.length-1].upper<q.max-1e-7)errors.push(`Cover the whole possible range, from ${q.min} to ${q.max}, not just the values in the sample.`);
 }
 const limitsOK=finite&&!errors.length;
 const counts=finite?rows.map(r=>q.data.filter(v=>v>=r.lower-1e-7&&v<=r.upper+1e-7).length):rows.map(()=>0);
 const frequencies=rows.map((r,i)=>limitsOK&&Number.isInteger(r.frequency)&&r.frequency===counts[i]);
 if(limitsOK&&!frequencies.every(Boolean))errors.push('Count the values in each of your own groups again. The frequencies must include every item exactly once.');
 return{rows,counts,limitsOK,frequencies,valid:limitsOK&&frequencies.every(Boolean),errors};
}

function assessComment(q,text,table){
 const raw=String(text||'').trim(),s=raw.toLowerCase().replace(/[–—]/g,'-').replace(/\b(?:centimetres?|centimeters?)\b/g,'cm');
 if(!raw)return{status:'incorrect',message:'Add a comment about the results in this context.'};
 if(!q.words.some(w=>new RegExp(`\\b${w}\\w*\\b`,'i').test(s)))return{status:'incorrect',message:`Relate your comment to ${q.context}.`};
 if(!table.valid)return{status:'incorrect',message:'Complete a valid table before checking the comment.'};
 const {rows,counts}=table,maximum=Math.max(...counts),minimum=Math.min(...counts),total=q.data.length;
 const observedExtreme=s.match(/\b(tallest|oldest|highest|heaviest|longest|greatest|largest|maximum|shortest|youngest|lowest|lightest|smallest|minimum)\b([^\d]*)(\d+(?:\.\d+)?)/);
 if(observedExtreme&&!/group|class|frequency|number|count/.test(observedExtreme[2])){
  const expected=/shortest|youngest|lowest|lightest|smallest|minimum/.test(observedExtreme[1])?Math.min(...q.data):Math.max(...q.data);
  return{status:close(+observedExtreme[3],expected)?'correct':'incorrect',message:close(+observedExtreme[3],expected)?'Your comment agrees with the recorded data.':'Check the smallest or largest recorded value.'};
 }
 let indexes=[];
 rows.forEach((r,i)=>{const lower=cleanNumber(r.lower).replace('.','\\.'),upper=cleanNumber(r.upper).replace('.','\\.');if(new RegExp(`\\b${lower}(?:\\s*(?:cm|kg|g|minutes?|years?|marks?|books?|pounds?))?\\s*(?:-|to|and)\\s*${upper}\\b`).test(s))indexes.push(i);});
 const ordinals=['first','second','third','fourth','fifth','sixth'];ordinals.forEach((name,i)=>{if(i<rows.length&&new RegExp(`\\b${name} (?:group|class|interval|category)`).test(s))indexes.push(i);});
 const groupNumber=s.match(/\bgroup\s+(\d+)\b/);if(groupNumber&&+groupNumber[1]>=1&&+groupNumber[1]<=rows.length)indexes.push(+groupNumber[1]-1);
 if(/\b(shortest|youngest|lowest[- ](?:score|scoring)|smallest|least expensive)\b/.test(s))indexes.push(0);
 if(/\b(tallest|oldest|highest[- ](?:score|scoring)|largest|most expensive)\b/.test(s))indexes.push(rows.length-1);
 if(/\bmiddle (?:group|class|interval)\b/.test(s)&&rows.length%2)indexes.push(Math.floor(rows.length/2));
 indexes=[...new Set(indexes)];
 const numbers=[...s.matchAll(/\d+(?:\.\d+)?/g)].map(m=>Number(m[0]));
 const most=/\b(most|highest|greatest|largest|biggest|commonest|popular|modal)\b/.test(s),fewest=/\b(fewest|least|lowest|smallest|rarest|uncommon)\b/.test(s),equal=/\b(equal|equally|same number|same frequency|tie|tied)\b/.test(s);
 const verdict=(ok,message)=>({status:ok?'correct':'incorrect',message:ok?'Your comment agrees with your table.':message});
 if(indexes.length){
  const count=indexes.reduce((n,i)=>n+counts[i],0),ratio=s.match(/\b(\d+)\s*(?:out of|of)\s*(?:the\s*)?(\d+)\b/),percent=s.match(/\b(\d+(?:\.\d+)?)\s*%/);
  if(ratio)return verdict(+ratio[1]===count&&+ratio[2]===total,'Check the number in those groups and the total number recorded.');
  if(percent)return verdict(Math.abs(+percent[1]-count/total*100)<=.5,'The percentage does not match those groups.');
 }
 if(indexes.length&&equal)return verdict(indexes.length>1&&indexes.every(i=>counts[i]===counts[indexes[0]]),'Those groups do not have the same frequency.');
 if(indexes.length&&/\b(majority|more than half|over half)\b/.test(s))return verdict(indexes.reduce((n,i)=>n+counts[i],0)>total/2,'Those groups do not contain more than half of the data.');
 if(indexes.length&&(most||fewest)){
  const target=fewest?minimum:maximum;
  // A number immediately attached to a contextual noun is a frequency claim.
  const claimed=s.match(/\b(\d+)\s+(?:of the\s+)?(?:plants?|students?|dogs?|customers?|parcels?|letters?|visitors?|members?|people|books?)\b/)
    ||s.match(/\b(?:frequency|contains?|has)\s*(?:of|is|was)?\s*(\d+)\b/);
  if(claimed&&indexes.length===1&&+claimed[1]!==counts[indexes[0]])return verdict(false,'The number in your comment does not match the frequency in that group.');
  return verdict(indexes.every(i=>counts[i]===target),`Check which group has the ${fewest?'fewest':'most'} items in your table.`);
 }
 if(indexes.length){
  const claimed=s.match(/\b(\d+)\s+(?:of the\s+)?(?:plants?|students?|dogs?|customers?|parcels?|letters?|visitors?|members?|people|books?)\b/);
  const frequencyClaim=s.match(/\b(?:frequency|total|count|contains?|has|have|there are|there were)\s*(?:of|is|was)?\s*(\d+)\b/);
  if(claimed||frequencyClaim){const n=+(claimed||frequencyClaim)[1];return verdict(n===indexes.reduce((v,i)=>v+counts[i],0),'The count in your comment does not match those groups.');}
  if(/\b(none|no (?:plants?|students?|dogs?|customers?|parcels?|letters?|visitors?|members?))\b/.test(s))return verdict(indexes.every(i=>counts[i]===0),'That group is not empty.');
 }
 if(equal&&!indexes.length)return verdict(counts.every(v=>v===counts[0]),'The group frequencies are not all equal.');
 const threshold=s.match(/\b(above|over|more than|greater than|below|under|less than|at least|at most)\s*(\d+(?:\.\d+)?)/);
 if(threshold){
  const op=threshold[1],cut=+threshold[2],count=q.data.filter(v=>op==='at least'?v>=cut:op==='at most'?v<=cut:/above|over|more than|greater than/.test(op)?v>cut:v<cut).length;
  if(/\b(no|none|nobody|zero)\b/.test(s))return verdict(count===0,'The raw data include values in the range described.');
  if(/\b(all|every)\b/.test(s))return verdict(count===total,'Not every recorded value meets that description.');
  if(/\b(majority|most|more than half|over half)\b/.test(s))return verdict(count>total/2,'That description does not cover most of the recorded values.');
  const claimed=s.match(/\b(\d+)\s+(?:plants?|students?|dogs?|customers?|parcels?|letters?|visitors?|members?|people|books?)\b/);
  if(claimed)return verdict(+claimed[1]===count,'Check the number of recorded values in that range.');
 }
 const range=s.match(/\b(?:range|vary|varies|between|from)\D*(\d+(?:\.\d+)?)\s*(?:-|to|and)\s*(\d+(?:\.\d+)?)/);
 if(range&&!indexes.length&&/\b(range|vary|varies|recorded|measured)\b/.test(s))return verdict(+range[1]===Math.min(...q.data)&&+range[2]===Math.max(...q.data),'Use the smallest and largest recorded values for the observed range.');
 const totalClaim=s.match(/\b(?:total of|altogether|in total|there are|there were)\s*(\d+)\b/)
   ||s.match(/\b(\d+)\s+(?:plants?|students?|dogs?|customers?|parcels?|letters?|visitors?|members?|people|books?)\s+(?:in total|altogether|overall)\b/);
 if(totalClaim&&!indexes.length)return verdict(+totalClaim[1]===total,'Check the total number of recorded items.');
 if(/\b(all|every)\b/.test(s)&&numbers.includes(q.min)&&numbers.includes(q.max))return verdict(true);
 if(raw.split(/\s+/).length<5)return{status:'incorrect',message:'Write a complete comment about what the results show, including the context.'};
 if((most||fewest)&&!indexes.length)return{status:'incorrect',message:'Say which group you mean, using its limits or its position in the table.'};
 return{status:'review',message:'Your table/chart can be marked now. This differently worded comment will be sent to Ryan for review.'};
}

function assessChartAxes(q,model,table){
 if(!q.chart)return{correct:true};
 const numbers=model.axisNumbers||[];
 const values=numbers.map(numberValue),step=values[1]-values[0];
 const scaleOK=numbers.length>=2&&values.every(Number.isFinite)&&values[0]===0&&step>0&&values.every((v,i)=>Math.abs(v-i*step)<1e-7)&&values[values.length-1]>=Math.max(...table.counts);
 const normal=v=>String(v||'').toLowerCase().replace(/[^a-z0-9]/g,'');
 const labels=model.axisLabels||{},yOK=/frequency|numberof|count/.test(normal(labels.y));
 const xOK=q.words.some(w=>normal(labels.x).includes(normal(w)))||normal(labels.x).includes(normal(q.measure));
 const groupsOK=(model.groupLabels||[]).length===q.groups&&table.rows.every((r,i)=>{
  const nums=String(model.groupLabels[i]||'').match(/\d+(?:\.\d+)?/g)||[];
  return nums.length===2&&Number(nums[0])===Number(r.lower)&&Number(nums[1])===Number(r.upper);
 });
 return{correct:scaleOK&&yOK&&xOK&&groupsOK,message:'Label both axes and each group. Number the frequency axis from 0 using equal steps that cover your tallest bar.'};
}

function assessGrouping(q,model){
 const table=assessTable(q,model),chart=(model.bars||[]).map((v,i)=>v!==null&&v!==''&&Number.isInteger(Number(v))&&Number(v)===table.counts[i]);
 const axis=assessChartAxes(q,model,table);
 const chartOK=!q.chart||(table.valid&&chart.length===q.groups&&chart.every(Boolean)&&axis.correct);
 const comment=q.comment?assessComment(q,model.comment,table):{status:'correct',message:''};
 const errors=[...table.errors];if(q.chart&&!chartOK)errors.push('Set every bar to the frequency in your table. Use the numbered frequency axis.');if(q.chart&&!axis.correct)errors.push(axis.message);if(q.comment&&comment.status!=='correct')errors.push(comment.message);
 return{table,chart,axis,comment,correct:table.valid&&chartOK&&comment.status!=='incorrect',errors};
}
function exampleGrouping(q,existing){
 const existingTable=existing&&assessTable(q,existing),width=Math.ceil((q.max-q.min+q.resolution)/q.groups/q.resolution)*q.resolution;
 const rows=existingTable?.limitsOK?existingTable.rows.map(r=>({lower:cleanNumber(r.lower),upper:cleanNumber(r.upper),frequency:0})):Array.from({length:q.groups},(_,i)=>({lower:cleanNumber(q.min+i*width),upper:cleanNumber(q.min+(i+1)*width-q.resolution),frequency:0}));
 rows.forEach(r=>r.frequency=q.data.filter(v=>v>=Number(r.lower)-1e-7&&v<=Number(r.upper)+1e-7).length);
 const most=rows.reduce((best,r,i)=>r.frequency>rows[best].frequency?i:best,0);
 const highestTied=rows.filter(r=>r.frequency===rows[most].frequency).length>1;
 const useFewest=q.id==='q6'||highestTied;
 const chosen=useFewest?rows.reduce((best,r,i)=>r.frequency<rows[best].frequency?i:best,0):most;
 const range=q.id==='q6'?rows[chosen].lower+'-'+rows[chosen].upper+' pounds':intervalLabel(rows[chosen],q);
 const descriptions={
 q1:`library members read ${range}`,
 q2:`students scored ${range}`,
 q3:`plants measured ${range} in height`,
 q4:`students took ${range} to travel to college`,
 q5:`letters weighed ${range}`,
 q6:`customers spent ${range}`,
 q7:`dogs were aged ${range}`,
 q8:`gym members exercised for ${range}`,
 q9:`parcels weighed ${range}`,
 q10:`visitors spent ${range} at the museum`
 };
 const tied=rows.filter(r=>r.frequency===rows[chosen].frequency).length>1;
 const peak=Math.max(...rows.map(r=>r.frequency),1);
 const intervals=Math.ceil(q.data.length/(q.tick||1));
 const axisStep=Math.max(1,Math.ceil(peak/intervals));
 const axisNumbers=Array.from({length:intervals+1},(_,i)=>i*axisStep);
 return{rows,bars:rows.map(r=>r.frequency),axisNumbers,axisLabels:{x:q.measure+' ('+q.unit+')',y:'Frequency'},groupLabels:rows.map(r=>r.lower+'–'+r.upper),comment:`The ${useFewest?"fewest":"highest"} number of ${descriptions[q.id]}.${tied?" This is a joint lowest frequency.":""}`};
}
function groupingSummary(q,model){return[(model.rows||[]).map(r=>`${intervalLabel(r,q)}: ${r.frequency}`).join('; '),q.chart?'Bar heights: '+(model.bars||[]).map(v=>v??'not drawn').join(', ')+'; Frequency axis: '+(model.axisNumbers||[]).join(', ')+'; Axis labels: '+JSON.stringify(model.axisLabels||{})+'; Group labels: '+(model.groupLabels||[]).join(', '):'',q.comment?'Comment: '+(model.comment||'(blank)'):''].filter(Boolean).join('\n');}

function GroupingEditor({question:q,model,onChange,checked,readOnly,example=false}){
 const rows=model.rows||emptyGrouping(q).rows;
 const changeRow=(i,key,value)=>onChange({...model,rows:rows.map((r,j)=>j===i?{...r,[key]:value}:r)});
 const field=(i,key)=>{
  const marked=checked&&(key==='frequency'?checked.table.frequencies[i]:checked.table.limitsOK);
  const colour=example?{backgroundColor:'#eff6ff',borderColor:'#60a5fa',color:'#1d4ed8'}:checked?(marked?GROUP_STYLES.correct:GROUP_STYLES.incorrect):{};
  return <label className="group-limit-field"><input type="text" inputMode={key==='frequency'||q.resolution===1?'numeric':'decimal'} aria-label={`Group ${i+1} ${key==='lower'?'lower limit':key==='upper'?'upper limit':'frequency'}`} value={rows[i]?.[key]??''} readOnly={readOnly} onChange={e=>changeRow(i,key,e.target.value)} style={colour}/></label>;
 };
 return <section className="group-editor">
  <div className="group-table-scroll"><table className="group-table" aria-label="Your grouped frequency table"><thead><tr><th scope="col">{q.measure}</th><th scope="col">Frequency</th></tr></thead><tbody>{rows.map((r,i)=><tr key={i}><td><div className="group-range-fields">{field(i,'lower')}<span>–</span>{field(i,'upper')}</div></td><td>{field(i,'frequency')}</td></tr>)}</tbody></table></div>
  {q.chart&&<GroupedBarChart question={q} model={model} checked={checked} readOnly={readOnly} example={example} onChange={onChange}/>}
  {q.comment&&<><label className="group-comment-label" htmlFor={`comment-${q.id}`}>One comment about the results</label><textarea id={`comment-${q.id}`} rows={3} aria-label="Comment about the results" value={model.comment||''} readOnly={readOnly} onChange={e=>onChange({...model,comment:e.target.value})} style={example?{backgroundColor:'#eff6ff',borderColor:'#60a5fa'}:checked?(checked.comment.status==='correct'?GROUP_STYLES.correct:checked.comment.status==='review'?GROUP_STYLES.review:GROUP_STYLES.incorrect):{}} placeholder="Explain what the table shows about the people or objects in the question."/></>}
 </section>;
}

function GroupedBarChart({question:q,model,checked,readOnly,example,onChange}){
 const drag=useRef(null),step=q.tick||1,tickCount=example&&model.axisNumbers?.length?model.axisNumbers.length:Math.ceil(q.data.length/step)+1;
 const enteredMax=Number((model.axisNumbers||[])[tickCount-1]);
 const max=enteredMax>0?enteredMax:(tickCount-1)*step,left=100,top=40,width=500,height=260,bottom=top+height,slot=width/q.groups;
 const edit=(key,index,value)=>{const next=[...(model[key]||[])];next[index]=value;onChange({...model,[key]:next});};
 const axisInput=(x,y,w,h,label,value,change)=> <foreignObject x={x} y={y} width={w} height={h}><input className="group-axis-input" aria-label={label} value={value??''} readOnly={readOnly} onChange={e=>change(e.target.value)} style={example?{background:'#eff6ff'}:checked?(checked.axis?.correct?GROUP_STYLES.correct:GROUP_STYLES.incorrect):{}}/></foreignObject>;
 const bars=model.bars||Array(q.groups).fill(null);
 const setBar=(index,value)=>{if(readOnly)return;const next=[...bars];next[index]=Math.max(0,Math.min(max,Math.round(Number(value)||0)));onChange({...model,bars:next});};
 const point=(event,index)=>{const svg=event.currentTarget.ownerSVGElement||event.currentTarget,rect=svg.getBoundingClientRect(),y=(event.clientY-rect.top)*400/rect.height;setBar(index,(bottom-y)/height*max);};
 return <section className="group-chart-editor" aria-label="Draw your bar chart">
  <h4>Draw a bar chart</h4><p className="group-note">Click or drag in a bar column to set its height.</p>
  <div className="group-chart-scroll"><svg viewBox="0 0 640 400" className="group-bar-chart" role="group" aria-label={`Bar chart of ${q.measure.toLowerCase()}`} onPointerMove={e=>{if(drag.current!==null)point(e,drag.current);}} onPointerUp={()=>drag.current=null} onPointerCancel={()=>drag.current=null}>
   {Array.from({length:tickCount},(_,i)=>{const y=bottom-i/(tickCount-1)*height;return <g key={i}><line x1={left} y1={y} x2={left+width} y2={y} stroke="#cbdde9"/>{axisInput(left-52,y-11,45,23,'Frequency axis number '+(i+1),(model.axisNumbers||[])[i],v=>edit('axisNumbers',i,v))}</g>;})}
   <path d={`M${left} ${top}V${bottom}H${left+width}`} fill="none" stroke="#17324d" strokeWidth="2"/>
   {axisInput(5,5,200,28,'Frequency axis label',model.axisLabels?.y,v=>onChange({...model,axisLabels:{...model.axisLabels,y:v}}))}
   {axisInput(210,365,280,28,'Horizontal axis label',model.axisLabels?.x,v=>onChange({...model,axisLabels:{...model.axisLabels,x:v}}))}
   {Array.from({length:q.groups},(_,i)=>{
    const value=Number(bars[i])||0,x=left+i*slot+slot*.18,barWidth=slot*.64,y=bottom-value/max*height;
    const colour=example?'#60a5fa':checked?(checked.chart[i]?'#25a973':'#df6969'):'#5c8ed6';
    return <g key={i}>
     <rect x={x} y={y} width={barWidth} height={value/max*height} fill={colour} stroke="#17324d" strokeWidth="1" pointerEvents="none"/>
     <rect x={left+i*slot} y={top} width={slot} height={height} fill="transparent" role="slider" tabIndex={readOnly?-1:0} aria-label={`Bar for group ${i+1}`} aria-valuemin={0} aria-valuemax={max} aria-valuenow={value} aria-disabled={readOnly} style={{cursor:readOnly?'default':'ns-resize'}}
      onPointerDown={e=>{if(readOnly)return;e.preventDefault();drag.current=i;e.currentTarget.ownerSVGElement.setPointerCapture(e.pointerId);point(e,i);}}
      onKeyDown={e=>{if(readOnly)return;if(['ArrowUp','ArrowDown','Home','End'].includes(e.key)){e.preventDefault();setBar(i,e.key==='Home'?0:e.key==='End'?max:value+(e.key==='ArrowUp'?1:-1));}}}/>
     {axisInput(left+i*slot+3,310,slot-6,32,'Group '+(i+1)+' chart label',(model.groupLabels||[])[i],v=>edit('groupLabels',i,v))}
    </g>;
   })}
  </svg></div>

 </section>;
}

const GROUP_STYLES={correct:{backgroundColor:'#e8f8ee',borderColor:'#42a96b'},incorrect:{backgroundColor:'#fdeaea',borderColor:'#d95858'},review:{backgroundColor:'#fff8df',borderColor:'#dca934'}};
const GROUP_CSS=`
.group-raw-data{display:grid;grid-template-columns:repeat(5,minmax(0,1fr));border-top:1px solid #aac0d1;border-left:1px solid #aac0d1;margin:12px 0 24px}
.group-raw-data span{padding:9px 6px;text-align:center;border-right:1px solid #aac0d1;border-bottom:1px solid #aac0d1;font-family:Inter,'Segoe UI',sans-serif}
.group-data-title{margin:14px 0 0;font-size:17px;color:#17324d}
.group-note{font-size:14px;line-height:1.6;color:#475569}
.group-table-scroll{overflow-x:auto;margin:14px 0 24px}
.group-table{border-collapse:collapse;width:100%;font-family:Inter,'Segoe UI',sans-serif}
.group-table th,.group-table td{padding:12px 8px;border:1px solid #70869b;text-align:center}
.group-table th{background:#eaf2f8;color:#17324d}.group-table small{font-weight:400}
.group-range-fields{display:flex;align-items:center;justify-content:center;gap:8px}.group-table th:first-child{width:68%}
.group-limit-field{display:flex;align-items:center;justify-content:center;gap:5px;white-space:nowrap;font-size:13px}
.group-limit-field input,.group-bar-inputs input{width:74px;max-width:100%;padding:9px 5px;border:2px solid #94a3b8;border-radius:5px;text-align:center;font:inherit;font-size:17px;box-sizing:border-box;background:white}
.group-comment-label{display:block;margin:22px 0 10px;font-weight:600}
.group-editor textarea{width:100%;box-sizing:border-box;padding:12px;border:2px solid #94a3b8;border-radius:6px;font:inherit;line-height:1.6}
.group-chart-editor{margin:22px 0}.group-chart-editor h4{margin-bottom:8px;color:#17324d}.group-bar-chart{width:100%;display:block;touch-action:none;background:#f9fcff;border:1px solid #c7d7e4;border-radius:8px}
.group-bar-chart [role=slider]:focus{outline:none;stroke:#e0a119;stroke-width:3px}
.group-bar-inputs{display:flex;gap:12px;flex-wrap:wrap;justify-content:center;margin:14px 0}.group-bar-inputs label{display:flex;flex-direction:column;align-items:center;gap:5px;font-size:13px}
.group-marking-notes{padding:12px 18px;background:#fff6e2;border-left:4px solid #d4a245;border-radius:5px;margin:15px 0;font-size:14px;line-height:1.6}
.group-chart-scroll{overflow-x:auto}.group-axis-input{width:100%;height:100%;box-sizing:border-box;min-width:0;border:1px solid #94a3b8;border-radius:3px;background:white;text-align:center;color:#17324d;font:13px Inter, sans-serif;padding:1px}
@media(max-width:600px){.group-table{table-layout:fixed;min-width:0;font-size:11px}.group-table th,.group-table td{padding:9px 4px}.group-table th{font-size:11px;line-height:1.4}.group-table th:first-child{width:68%}.group-range-fields{gap:5px}.group-limit-field{flex-wrap:wrap;gap:3px;font-size:11px}.group-limit-field input{width:52px;font-size:16px}.group-raw-data span{padding:8px 3px}.group-bar-chart{min-width:480px}}
`;

// Generate short feedback tones locally, without loading audio files.
let quizAudioContext;
async function playQuizFeedback(correct) {
  try {
    const AudioContextClass = window.AudioContext || window.webkitAudioContext;
    if (!AudioContextClass) return;
    if (!quizAudioContext || quizAudioContext.state === "closed") quizAudioContext = new AudioContextClass();
    if (quizAudioContext.state === "suspended") await quizAudioContext.resume();
    const context = quizAudioContext;
    const start = context.currentTime;
    const oscillator = context.createOscillator();
    const volume = context.createGain();
    oscillator.type = correct ? "sine" : "triangle";
    oscillator.frequency.setValueAtTime(correct ? 880 : 240, start);
    if (correct) oscillator.frequency.setValueAtTime(1174.66, start + 0.07);
    else {
      oscillator.frequency.exponentialRampToValueAtTime(170, start + 0.1);
      oscillator.frequency.setValueAtTime(210, start + 0.14);
      oscillator.frequency.exponentialRampToValueAtTime(130, start + 0.28);
    }
    const duration = correct ? 0.2 : 0.3;
    volume.gain.setValueAtTime(0.0001, start);
    volume.gain.exponentialRampToValueAtTime(correct ? 0.15 : 0.14, start + 0.008);
    if (!correct) {
      volume.gain.exponentialRampToValueAtTime(0.0001, start + 0.11);
      volume.gain.setValueAtTime(0.0001, start + 0.14);
      volume.gain.exponentialRampToValueAtTime(0.14, start + 0.15);
    }
    volume.gain.exponentialRampToValueAtTime(0.0001, start + duration);
    oscillator.connect(volume);
    volume.connect(context.destination);
    oscillator.onended = () => { oscillator.disconnect(); volume.disconnect(); };
    oscillator.start(start);
    oscillator.stop(start + duration + 0.01);
  } catch {
    // Audio availability should never interrupt answer checking.
  }
}
